import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Modal } from "@proda-ai/ui-kit";

export const testIds = {
    main: "ResetRowChangesModal-modal",
};
export type ResetRowChangesModalProps = {
    showModal: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ResetRowChangesModal = ({
    showModal,
    onConfirm,
    onCancel,
}: ResetRowChangesModalProps) => {
    const modalTitle = (
        <Box>
            <Typography variant="body2">
                Are you sure you want to <strong>reset to original?</strong>
            </Typography>
        </Box>
    );

    return (
        <Modal
            data-testid={testIds.main}
            open={showModal}
            onClose={onCancel}
            onCancel={onCancel}
            onConfirm={() => {
                onConfirm();
            }}
            headerTitle={modalTitle}
            title="Reset to original"
        >
            <Typography variant="body3">
                {`Are you sure you want to reset to original? Any changes you have made will be lost.`}
            </Typography>
        </Modal>
    );
};
